import MenuIcon from "@mui/icons-material/Menu";
import { Box, IconButton, Menu } from "@mui/material";
import React, { FunctionComponent } from "react";
import { Pages } from "../../types/utils";
import DropDownBurgerMenuButton from "./DropDownBurgerMenuButton";

const style = {
  icon: {
    padding: "0px 0px 0px 0px",
    color: "#000000",
  },
  menu: {
    mt: "45px",
  },
};

const MenuButton: FunctionComponent<{
  links: Pages;
}> = ({ links }) => {
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <Box
      sx={{
        flexGrow: 0,
        marginLeft: "auto",
      }}
    >
      <IconButton onClick={handleOpenUserMenu} size="large" aria-label="menu" sx={style.icon}>
        <MenuIcon fontSize="large" />
      </IconButton>
      <Menu
        sx={style.menu}
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        {Object.entries(links).map(([key, value]) => (
          <DropDownBurgerMenuButton
            key={key}
            menuButton={{
              text: key,
              link: value,
              onClickCallback: handleCloseUserMenu,
            }}
          />
        ))}
      </Menu>
    </Box>
  );
};

export default MenuButton;
